import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ScrollToTop from "./components/common/ScrollToTop";
import Layout from "./components/layout";
import ProtectedRoute from "./components/common/ProtectedRoute";
import { useSelector } from "react-redux";
import { RootState } from "./utils/store";
import Loader from "./components/common/Loader";

const Login = lazy(() => import("./pages/Login"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const LoginOtp = lazy(() => import("./pages/LoginOtp"));
const ChangePassword = lazy(() => import("./pages/ChangePassword"));
const Dashboard = lazy(() => import("./pages/AuthPages/Dashboard"));
const MyAppointment = lazy(() => import("./pages/AuthPages/MyAppointment"));
const Help = lazy(() => import("./pages/AuthPages/Help"));
const RpmAlertManagement = lazy(() => import("./pages/AuthPages/RpmAlertManagement"));
const RPMAlertManagementDetails = lazy(() => import("./pages/AuthPages/RPMAlertManagementDetails"));
const LabTests = lazy(() => import("./pages/AuthPages/LabTests"));
const LabTestDetails = lazy(() => import("./pages/AuthPages/LabTestDetails"));
const ProfilePage = lazy(() => import("./pages/AuthPages/Profile"));
const MyPatient = lazy(() => import("./pages/AuthPages/MyPatient"));
const AllPatient = lazy(() => import("./pages/AuthPages/AllPatient"));
const DoctorChat = lazy(() => import("./pages/AuthPages/DoctorChat"));
const PatientChat = lazy(() => import("./pages/AuthPages/PatientChat"));
const Setting = lazy(() => import("./pages/AuthPages/Setting"));
const HealthCheckups = lazy(() => import("./pages/AuthPages/HealthCheckups"));

const App = () => {
  const token = useSelector((state: RootState) => state.auth.token);

  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path='/login' element={<Login />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/otp' element={<LoginOtp />} />
          <Route path='/change-password' element={<ChangePassword />} />

          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path='myaccount/profile' element={<ProfilePage />} />
            <Route path='dashboard' element={<Dashboard />} />
            <Route path='Appointments' element={<MyAppointment />} />
            <Route path='help' element={<Help />} />
            <Route path='RPMAlert' element={<RpmAlertManagement />} />
            <Route path='RPMAlert/details' element={<RPMAlertManagementDetails />} />
            <Route path='LabTests' element={<LabTests />} />
            <Route path='LabTests/details' element={<LabTestDetails />} />
            <Route path='health-checkups' element={<HealthCheckups />} />
            <Route path='patient/MyPatient' element={<MyPatient />} />
            <Route path='patient/AllPatient' element={<AllPatient />} />
            <Route path='chat/doctor' element={<DoctorChat />} />
            <Route path='chat/patient' element={<PatientChat />} />
            <Route path='myaccount/settings' element={<Setting />} />
            <Route path='*' element={<Dashboard />} />
            <Route path="/*" element={<Navigate to={"/dashboard"} replace />} />
          </Route>

          <Route
            path="/*"
            element={<Navigate to={!token ? "/login" : "/"} replace />}
          />
        </Routes>
      </Suspense>
    </>
  );
};

export default App;
